<template>
    <section class="page-section">
        <v-container v-if="this.$slots['default']">
            <slot />
        </v-container>
        <slot v-if="this.$slots['pageSectionImmersive']" name="pageSectionImmersive" />
    </section>
</template>

<script>
export default{
    props : {
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>

<style scoped>
.page-section{
    position:relative;
    padding-top: var(--page-section-p);
}
.page-section--py{
    padding: var(--page-section-p) 0;
}
.page-section--sm{
    padding-top: var(--page-section-p-sm);
}
.page-section--first{
    padding-top: var(--contents-py);
    margin-top: calc(var(--contents-py) * -1);
}
.page-section--last{
    padding-bottom: var(--contents-py);
    margin-bottom: calc(var(--contents-py) * -1);
}
.page-section__bg{
    position: absolute;
    top:0;
    left:50%;
    -webkit-transform: translate(-50%,0); -ms-transform: translate(-50%,0); transform: translate(-50%,0);
    z-index: -1;
    display: block;
    width: 100vw;
    height: 100%;
    background-repeat: no-repeat;
    background-position:center;
    background-size: cover;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}
</style>